import {EnvironmentProviders, ErrorHandler, importProvidersFrom, Provider, provideZoneChangeDetection} from '@angular/core';
import {HttpInterceptorFn, provideHttpClient, withInterceptors, withXhr} from "@angular/common/http";
import {I18nService, provideI18nHttpLoader} from "./services/i18n/i18n.service";
import {provideMissingTranslationHandler, provideTranslateService} from "@ngx-translate/core";
import {authInterceptor} from "./services/auth/auth.interceptor";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {errorInterceptor} from "./repositories/error.interceptor";
import {searchRetryInterceptor} from "./repositories/search-retry.interceptor";
import {viewerTokenInterceptor} from "./repositories/viewer-token.interceptor";
import {NgbPopoverConfig} from "@ng-bootstrap/ng-bootstrap";
import {AccPopoverConfig} from "./services/ngbd-popover.config";
import {NotificationService} from "./services/notification/notification.service";
import {QuillModule} from "ngx-quill";
import {AccMissingTranslationHandler} from "./services/i18n/acc-missing-translation-handler";
import {stateInterceptor} from "./services/state/state.interceptor";
import {pendingRequestInterceptor} from "./services/request/pending-request.interceptor";
import {environment} from "../environments/environment";
import {GlobalErrorHandler} from "./base/global-error.handler";
import {LoggingService} from "./services/logger/logging.service";

/**
 * Alles ausser dem Router, gemeinsam fuer Dashboard und Browser-Viewer (app.config.ts, app.config.viewer.ts). Der Viewer
 * stellt `leadingInterceptors` einen eigenen voran, damit keine API-Anfrage die uebrigen erreicht.
 */
export function appProviders(leadingInterceptors: HttpInterceptorFn[]): (Provider | EnvironmentProviders)[] {
  return [
    // Ohne diesen Provider startet Angular seit 21 zoneless; Dashboard und Viewer verlassen sich auf zone.js.
    provideZoneChangeDetection(),
    // viewerTokenInterceptor steht vor den uebrigen, damit der Kopf gesetzt ist, bevor searchRetryInterceptor eine
    // Anfrage wiederholt - sonst liefe der zweite Versuch ohne Token in ein 403. pendingRequestInterceptor steht ganz
    // vorn: Er muss die Anfrage noch im Klick sehen, ein wartender Interceptor davor schoebe sie aus dem Klick hinaus.
    provideHttpClient(withXhr(), withInterceptors([pendingRequestInterceptor, ...leadingInterceptors, viewerTokenInterceptor, authInterceptor, errorInterceptor,
                                                   stateInterceptor, searchRetryInterceptor])),
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      QuillModule
    ),
    {provide: ErrorHandler, useClass: GlobalErrorHandler, deps: [NotificationService, I18nService, LoggingService]},
    // I18N
    provideTranslateService({
      loader: provideI18nHttpLoader(),
      missingTranslationHandler: provideMissingTranslationHandler(AccMissingTranslationHandler),
      fallbackLang: environment.i18n.defaultLang
    }),
    // Configs
    {provide: NgbPopoverConfig, useClass: AccPopoverConfig},
  ];
}
